let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("hxZ2q"), load("gC5n8"), load("19uFC"), load("hhss7"), load("iV6RN")]).then(() => parcelRequire('kPKkS'));